export default (options) => {
  return {
    event: options.event,
    ecommerce: {
      [options.typePromo]: {
        promotions: [
          {
            name: 'American Express,Santander ',
            id: 'Cobrand_Af',
            creative: options.descripcion,
            position: 'MYB',
          },
        ],
      },
    },
  };
};